import * as angular from 'angular';
import * as _ from 'lodash';

import { TicketViewModel, ApplicationUserViewModel, Ticket, IDictionaryAssignableStatuses } from '../../models';
import { IPictureDictionary } from '.';
import { guidEmpty } from '../../common';

export interface ITicketViewModelService {
    buildViewModels(ticketList: Ticket[], userViewModels: ApplicationUserViewModel[], userPictures: IPictureDictionary, assignableStatuses: IDictionaryAssignableStatuses): TicketViewModel[];
    setAssignableStatuses(ticketViewModels: TicketViewModel[], assignableStatuses: IDictionaryAssignableStatuses): TicketViewModel[];
    getUniqueUserList(tickets: Ticket[]): string[];
}

export class TicketViewModelService implements ITicketViewModelService {

    static serviceId = 'ticketViewModelService';

    static $inject = ['$translate'];

    constructor(private _$translate: angular.translate.ITranslateService) {
    }

    buildViewModels(ticketList: Ticket[],
        userViewModels: ApplicationUserViewModel[],
        userPictures: IPictureDictionary,
        assignableStatuses: IDictionaryAssignableStatuses): TicketViewModel[] {

        let ticketViewModelList: TicketViewModel[] = [];
        
        ticketList.forEach(ticket => {
            const ticketViewModel: TicketViewModel = {
                model: ticket,
                creationUser: {} as any,
                lastModifier: {} as any,
                assignedUser: {} as any,
                closedUser: {} as any,
                completedUser: {} as any,
                assignableStatuses: [],
                activitiesViewModelList: []
            };
            ticketViewModelList.push(ticketViewModel);
        });

        ticketViewModelList = this.fillUserViewModelDetails(ticketViewModelList, userViewModels, userPictures);
        ticketViewModelList = this.setAssignableStatuses(ticketViewModelList, assignableStatuses);
        
        return ticketViewModelList;
    }

    // Set assignable statuses
    // NO API call
    setAssignableStatuses(ticketViewModels: TicketViewModel[], assignableStatuses: IDictionaryAssignableStatuses): TicketViewModel[] {
        ticketViewModels.forEach(ticketVieWModel => {
            if (assignableStatuses[ticketVieWModel.model.id]) {
                ticketVieWModel.assignableStatuses = assignableStatuses[ticketVieWModel.model.id];
            } else {
                ticketVieWModel.assignableStatuses = [];
            }
        });
        return ticketViewModels;
    }

    // Fill in ticket view model ith all needed information
    // NO API call
    private fillUserViewModelDetails(ticketViewModels: TicketViewModel[], users: ApplicationUserViewModel[], userPictures: IPictureDictionary): TicketViewModel[] {
        ticketViewModels.forEach(ticketViewModel => {
            // Set creator details
            const foundCreationUser = _.find(users, user => user.userId === ticketViewModel.model.creationUser);
            if (foundCreationUser) {
                ticketViewModel.creationUser = foundCreationUser;
                ticketViewModel.creationUser.picture = userPictures[foundCreationUser.userId] ? 'data:image/png;base64,' + userPictures[foundCreationUser.userId] : undefined;
            }

            // Set modifier details
            const foundModifier = _.find(users, user => user.userId === ticketViewModel.model.lastModifier);
            if (foundModifier) {
                ticketViewModel.lastModifier = foundModifier;
                ticketViewModel.lastModifier.picture = userPictures[foundModifier.userId] ? 'data:image/png;base64,' + userPictures[foundModifier.userId] : undefined;
            }

            // Set assignee details
            const foundAssignee = _.find(users, user => user.userId === ticketViewModel.model.assignedUser);
            if (foundAssignee) {
                ticketViewModel.assignedUser = foundAssignee;
                ticketViewModel.assignedUser.picture = userPictures[foundAssignee.userId] ? 'data:image/png;base64,' + userPictures[foundAssignee.userId] : undefined;
            } else {
                ticketViewModel.assignedUser = {} as any;
                ticketViewModel.assignedUser.displayName = this._$translate.instant('Unassigned');
            }

            // Set closed user details
            const foundClosedUser = _.find(users, user => user.userId === ticketViewModel.model.closedUser);
            if (foundClosedUser) {
                ticketViewModel.closedUser = foundClosedUser;
                ticketViewModel.closedUser.picture = userPictures[foundClosedUser.userId] ? 'data:image/png;base64,' + userPictures[foundClosedUser.userId] : undefined;
            }

            // Set completed user details
            const foundCompletedUser = _.find(users, user => user.userId === ticketViewModel.model.completedUser);
            if (foundCompletedUser) {
                ticketViewModel.completedUser = foundCompletedUser;
                ticketViewModel.completedUser.picture = userPictures[foundCompletedUser.userId] ? 'data:image/png;base64,' + userPictures[foundCompletedUser.userId] : undefined;
            }
        });
        return ticketViewModels;
    }
    
    // Retrieve all user Id used in tickets and returen an array with unique value of user id
    // NO API call
    getUniqueUserList(tickets: Ticket[]): string[] {
        let userIdList: string[] = [];
        tickets.forEach(ticket => {
            userIdList.push(ticket.creationUser);
            userIdList.push(ticket.lastModifier);
            userIdList.push(ticket.assignedUser);
            userIdList.push(ticket.completedUser);
            userIdList.push(ticket.closedUser);
        });
        userIdList = _.uniq(userIdList);
        userIdList = userIdList.filter(userId => userId && userId !== guidEmpty);
        return userIdList;
    }
}